<div 
	ngbDropdown 
	class="d-flex"
	[autoClose]="'outside'"
	(openChange)="open = !open"
	#dropdown="ngbDropdown"
>
 
	<button 
		type="button" 
		class="btn"
		[ngStyle]="styles"
		[disabled]="!options || options.length === 0"
		ngbDropdownToggle
		#toggle
	>
		<span *ngIf="!enableSearch || (enableSearch && !open)">{{placeholder}}</span>

		<span *ngIf="options && options.length > 0" class="ico-arrow-bottom"></span>
	</button>

	<input 
		type="text" 
		class="search" 
		autocomplete="off" 
		#input
		appFocus
		[focus]="searchFocusEvent"
		[ngClass]="enableSearch && open ? 'visible' : ''"
		[(ngModel)]="search"
		(click)="$event.stopPropagation()"
		(keydown.enter)="onEnter($event)"
	>

	 <div ngbDropdownMenu #menu>
		<!-- Grouped Mode -->
		<div class="items" *ngIf="grouped && filteredGroups && filteredGroups.length > 0">
			<ng-container *ngFor="let group of filteredGroups">
				<div class="dropdown-group-label pl-2">{{ group.groupLabel }}</div>
				<button
					type="button"
					class="dropdown-item"
					*ngFor="let item of group.items"
					(click)="setValue(item, dropdown)"
					>
					{{ item.label }}
				</button>
			</ng-container>
		</div>

		<!-- Normal Mode -->
		<div class="items" *ngIf="!grouped && filteredFlat && filteredFlat.length > 0">
			<button
				type="button"
				class="dropdown-item"
				*ngFor="let option of filteredFlat"
				(click)="setValue(option, dropdown)"
			>
				{{ option.label }}
			</button>
		</div>

		<p *ngIf="
			(grouped && (!filteredGroups || filteredGroups.length === 0)) ||
			(!grouped && (!filteredFlat || filteredFlat.length === 0))
		">
			No options to show
		</p>
	</div>
</div>
